export default {
    apiURL: import.meta.env.VITE_API_URL || '',
    mode: import.meta.env.MODE, // "development" | "staging" | "production" | etc.
};
